<template>
  <div>
    <template v-if="routeMatchesComponent()">
      <!-- TODO Improves -->
      <div v-if="firstLoad" class="m3 my3">
        <div class="p3 white-bg flex my3 justify-center"><span>{{ getReferencelabel("BOOKING_TEXT") }} <a class="underline pointer" href="/reservation/paiementsolde" target="blank">{{ getReferencelabel("CLICK_HERE") }}</a>.</span></div>
        <div v-if="!ordersListing.value.length" class="p3 white-bg flex my3">
          <span class="flex flex-auto h5n semi-bold justify-center">Retrouvez ici toutes vos informations dès que vous aurez effectué votre 1ère réservation avec l'UCPA.</span>
        </div>
        <div v-for="(order, index) in ordersListing.value" v-else :key="index" class="py1 white-bg my3">
          <div class="col-12 flex flex-wrap py1">
            <div class="col-12 flex flex-column items-center">
              <span class="blue h3n bold center">{{ genericOrderObject(order).productName }}</span>
              <p class="h4n bold m0 py2 center"><!-- {{ genericOrderObject(order).description }},  -->{{ genericOrderObject(order).date }}</p>
              <router-link :to="{ name: 'DetailsOrder', params: { uuid: order.bookingNumber} }" class="h5n blue semi-bold underline">{{ getReferencelabel("MORE") }}</router-link>
            </div>
            <div v-if="userUuid" class="col-12 flex justify-center mt1">
              <!-- <Button text="Modifier" class="inline-block col-8 md-col-6 lg-col-4 my2" btn-color="blue" :action="editPurchase.bind(this, order.uuid)"></Button> -->
              <!-- Paiement solde  -->
              <div v-if="/* order.order_source === 'speedboat' && */ order.paymentDetails && order.paymentDetails.solde && order.paymentDetails.pay_remaining_link" class="flex flex-column col-12 items-center p1">
                <Button :reference="genericOrderObject(order).status === 'Réservation' ? 'SETTLE_BALANCE' : 'BOOK'" class="col-12 md-col-6 lg-col-4 my2" btn-color="red" :action="goToPaymentSolde.bind(this, order)" />
                <a v-if="order.paymentDetails.bankDetailsLink" class="underline pointer bold bank-details text-center" :href="order.paymentDetails.bankDetailsLink" target="blank">{{ getReferencelabel("CHANGE_BANK_DETAILS") }}</a>
              </div>
            </div>
          </div>
        </div>
        <div v-if="showMoreButton" class="flex flex-wrap justify-center">
          <Button reference="SEE_MORE" class="col-8 md-col-6 lg-col-4 mb3" btn-color="inverted" :action="loadMoreOrders" />
        </div>
      </div>
    </template>
    <router-view v-else />
  </div>
</template>

<script>

import { onMounted, ref, reactive, computed, getCurrentInstance } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import Button from '@/components/elements/Button';
import Breadcrumb from '@/components/common/Breadcrumb';
import { getReferencelabel, routeIsCurrentComponent } from '@/mixins/utils';

import { getOrders } from '@/mixins/requests';

export default {
  components: {
    Breadcrumb,
    Button
  },
  setup () {
    const store = useStore();
    const route = useRoute();

    const routeMatchesComponent = () => routeIsCurrentComponent(route.name, getCurrentInstance());

    const firstLoad = ref(false);
    const start = ref(0);
    const limit = ref(3);
    const ordersCount = ref(0);
    const ordersListing = reactive([]);
    const userUuid = ref(store.state.user.uuid);
    const userIresaIds = ref(store.state.user.iresa_ids);

    // Total of fetched orders without filters
    const totalSyncOrderCount = ref(0);
    const showMoreButton = computed(() => ordersCount.value > totalSyncOrderCount.value);

    function goToPaymentSolde (order) {
      // window.open(
      //   `/reservation/paiementsolde?booking=${order.bookingNumber}&customer=${order.customer_id}`,
      //   '_blank'
      // ); // <-- This is how it opens a new tab

      window.open(order.paymentDetails.pay_remaining_link);
    }

    function genericOrderObject (data) {
      // if (data.order_source === 'alpha') {
      //   return {
      //     productName: data.order.order_items[0].product_name,
      //     description: data.order.order_items[0].horanet_product_name,
      //     date: data.date,
      //     status: data.order.status
      //   };
      // }
      return {
        productName: data.mainProduct,
        description: data.mainProduct,
        date: `${data.startDate} - ${data.endDate}`,
        status: data.status
      };
    }

    async function loadMoreOrders () {
      start.value += limit.value;
      await syncOrders();
    }

    async function syncOrders () {
      store.commit('setLoading', true);
      const { count, items } = await getOrders(start.value, limit.value);

      ordersCount.value = count;
      totalSyncOrderCount.value += items.length;

      ordersListing.value = [...ordersListing.value || [], ...items.filter(o => o.status !== 'Option' && o.status !== 'Annulé')];

      store.commit('setLoading', false);
    }

    onMounted(async () => {
      await syncOrders();
      firstLoad.value = true;
    });

    return { firstLoad, start, limit, ordersCount, ordersListing, userUuid, showMoreButton, goToPaymentSolde, genericOrderObject, loadMoreOrders, syncOrders, route, getReferencelabel, routeMatchesComponent };
  }
};
</script>

<style>

</style>
